import { render, staticRenderFns } from "./LabelField.vue?vue&type=template&id=926273d0&scoped=true"
import script from "./LabelField.vue?vue&type=script&lang=js"
export * from "./LabelField.vue?vue&type=script&lang=js"
import style0 from "./LabelField.vue?vue&type=style&index=0&id=926273d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926273d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
